module.exports = __webpack_public_path__ + "static/media/icons.0c7c24f3.png";